import { Drawer, DrawerBody, DrawerHeader, DrawerHeading, useOpen } from "@dgs/core";
import { FC, MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { RenderBlock } from "../../RenderRegistrationBlock";

interface Props {
	blockId: number;
}

const Button = styled.button`
	all: unset;

	&:hover,
	&:focus-visible {
		text-decoration: underline;
	}
`;

export const HotelInfoDrawer: FC<Props> = ({ blockId }) => {
	const { t } = useTranslation();
	const drawer = useOpen();

	const handleOpen = (e: MouseEvent) => {
		e.stopPropagation();
		drawer.handleOpen();
	};

	return (
		<>
			<Button type="button" onClick={handleOpen}>
				{t("More information")}
			</Button>
			<Drawer open={drawer.open} onClose={drawer.handleClose}>
				<DrawerHeader onClose={drawer.handleClose}>
					<DrawerHeading>{t("More information")}</DrawerHeading>
				</DrawerHeader>
				<DrawerBody>
					<RenderBlock blockId={blockId} />
				</DrawerBody>
			</Drawer>
		</>
	);
};
